import { render, staticRenderFns } from "./TeamMatches.vue?vue&type=template&id=32993bb1&scoped=true&lang=pug&"
import script from "./TeamMatches.vue?vue&type=script&lang=js&"
export * from "./TeamMatches.vue?vue&type=script&lang=js&"
import style0 from "./TeamMatches.vue?vue&type=style&index=0&id=32993bb1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32993bb1",
  null
  
)

export default component.exports